//Utils
import 'Scripts/utils/Scroll'
import { isTouchDevice } from 'Scripts/utils/utils'
//Vendor
import gsap from 'gsap'
import Lenis from '@studio-freight/lenis'

//Components
import Preloader from 'Scripts/components/Preloader'
import Header from 'Scripts/components/header'
import Transition from 'Scripts/components/Transition'
import Intro from 'Scripts/components/Intro'
//Pages
import Home from 'Scripts/pages/Home'
import Map from 'Scripts/pages/Map'
import Profiler from 'Scripts/pages/Profil'

class App {
  constructor() {
    //Variables
    this.template = document.querySelector('body').dataset.page
    this.theme = document.querySelector('body').dataset.theme
    this.isMap = this.template === 'map'
    //Developed by
    this.developedBy()
    //    
    isTouchDevice() && document.documentElement.classList.add('isTouchDevice')

    //Methods
    //Smooth Scroll : Lenis
    if (!this.isMap) {
      this.initSmoothScrolling()      
      //Intro 
      this.initIntro()
    }
    //Transition
    this.initTransition()
    //Pages
    this.createPage()
    //Preloader
    this.createPreloader()
    //Listeners
    this.addEventListeners()
  }

  //Developed by
  developedBy() {
    console.log("%cDeveloped by Studio-MB : https://mahdibamoulid.com", "color:white; font-style: italic; background-color: blue; padding: 5px")
  }

  //Preloader
  createPreloader() {
    this.preloader = new Preloader({
      selector: '#preloader__wrapper',
      counter: '.preloader__counter',
      logo: '.preloader__logo',
      intro: '.preloader__text',
    })
  }

  //On siteweb Preloaded
  async onPreloaded() {
    //show Transition page
    await this.transition.show({ color: '#257d76' })
    //Hide Preloader
    this.preloader.destroy()
    //Play intro video
    !this.isMap && this.intro.play()
    //
    //Hide transition page
    await this.transition.hide()
  }

  async onIntroEnded() {
    //show Transition page
    await this.transition.show({ color: '#257d76' })
    //Destroy intro video
    this.intro.destroy()
    //profiler
    this.initProfiler()
    //Init Chat : Tidio
    this.initChat()
    //Hide transition page
    await this.transition.hide()
  }

  //Transition
  initTransition() {
    this.transition = new Transition()
  }

  //Create pages
  createPage() {
    // this.page = new Home()
    switch (this.template) {
      case 'home':
      case 'accueil':
        this.page = new Home()
        break;
      case 'map':
        this.page = new Map()
        break;
      default:
        this.page = new Home()
    }
  }

  initChat() {
    const tidioScript = document.createElement('script')
    tidioScript.src = `https://code.tidio.co/${process.env.TIDIO}.js`
    document.body.appendChild(tidioScript)
  }

  //Intro
  initIntro() {
    this.intro = new Intro({
      container: '.intro',
      elements: {
        skip: '.skip',
        unmute: '.unmute',
        video: 'video'
      }
    })
  }

  async onPageUpdated() {
    //show Transition page
    await this.transition.show({ color: '#f4e68e' })
    //enable scroll
    document.querySelector('body').classList.remove('stop-scrolling')
    this.lenis.scrollTo(0, { immediate: true })
    //Hide Profiler
    gsap.set(this.profiler.container, { autoAlpha: 0 })
    //Active service click
    document.documentElement.classList.remove('getService')

    //Hide transition page
    await this.transition.hide()

    //header
    this.initHeader()

    //Init Chat : Tidio
    // this.initChat()

    //Show page
    this.page.show()
  }

  async showProfilPage(e) {
    e.preventDefault()

    //show Transition page
    await this.transition.show({ color: '#f4e68e' })
    //Profiler
    this.profiler.reset()
    gsap.set(this.profiler.container, { autoAlpha: 1 })

    //Hide transition page
    await this.transition.hide()
  }

  initProfiler() {
    this.profiler = new Profiler()
  }

  initHeader() {
    this.header = new Header({ selector: '#header', scroller: this.lenis })
  }

  //https://github.com/studio-freight/lenis)
  initSmoothScrolling() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
      direction: 'vertical',
      smooth: true,
      // smoothTouch: true,
      // touchMultiplier: 2,
    })

    const scrollFn = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(scrollFn)
    }
    requestAnimationFrame(scrollFn)
  }

  addEventListeners() {
    window.addEventListener('resize', this.onResize.bind(this))
    window.addEventListener('pageUpdated', this.onPageUpdated.bind(this))
    this.preloader.once('completed', this.onPreloaded.bind(this))
    window.addEventListener('videoEnded', this.onIntroEnded.bind(this))
    document.querySelector('#profilTrigger')?.addEventListener('click', this.showProfilPage.bind(this))
  }
  // 

  onResize() {
    if (this.page && this.page.onResize) {
      this.page.onResize()
    }
  }

  onUpdate() {
    if (this.page && this.page.onUpdate) {
      this.page.onUpdate()
    }
  }

  update() {
    this.page && this.page.update()
    window.requestAnimationFrame(this.update.bind(this))
  }

}
new App()
